import React, { useCallback } from 'react';
import { ExtraMobileActionsWrapper, LogoWrapper, UserMenuWrapper, Wrapper } from './styled';
import Logo from 'components/navigation/Logo';
import { NavigateToFn, Route, State as RouteState } from 'config/routes';
import { UserMenu } from '../UserMenu';
import { HeaderSaveNeighbourhoodWidget } from 'screens/Investors/Neighbourhood/sections/Overview/HeaderSaveNeighbourhoodWidget';
import { connect } from 'react-redux';
import { prevRouteSelector, routeSelector } from 'store/state/selectors/router';
import { State } from 'store/state';
import { useLocale } from 'locale';
import ArrowRightIcon from 'assets/svg/arrow-right.svg';
import { useScreenBreakpoint } from 'consts/breakpoints';
import { SmallText } from 'ds/components/typography';
import { navigateTo } from 'store/state/router/actions';
import { neighborhoodSummaryDemographicSelector } from 'store/state/domainData/selectors/investors';
import { ILocalPageResponse } from 'utils/entities';


const BACK_BUTTON_ROUTES = new Set([
  Route.InvestorsProfilePage,
  Route.InvestorsFavoriteNeighourhoodPage,
  Route.InvestorsSearchPage,
  Route.InvestorsNeighbourhoodPage,
]);

interface IInvestorHeader {
  onLogout: () => void;
  route: RouteState;
  navigate: NavigateToFn;
  prevRoute: RouteState;
  localData: ILocalPageResponse['searchLocal2'];
}

export const HeaderBase: React.FC<IInvestorHeader> = ({ onLogout, route, navigate, prevRoute, localData }) => {
  const { t } = useLocale();
  const isDevice = useScreenBreakpoint() < 3;
  const withBackLink = BACK_BUTTON_ROUTES.has(route.name) && isDevice;
  const isCompare = Boolean(route.name === Route.InvestorsNeighbourhoodPage && route.params && route.params.compareId);

  const handleClick = useCallback(() => {
    if (prevRoute) {
      window.history.back();
    }
    else {
      navigate(Route.InvestorsHomePage, {}, { replace: true });
    }
  }, [ prevRoute, navigate ]);

  let headerNameContent = null;

  switch (true) {
    case route.name === Route.InvestorsProfilePage:
      headerNameContent = <SmallText weight="bold">{t('investors.backButton.page.profile')}</SmallText>;
      break;
    case route.name === Route.InvestorsFavoriteNeighourhoodPage:
      headerNameContent = <SmallText weight="bold">{t('investors.backButton.page.favoriteHood')}</SmallText>;
      break;
    case route.name === Route.InvestorsSearchPage:
      headerNameContent = <SmallText weight="bold">{t('investors.backButton.page.search')}</SmallText>;
      break;
    case route.name === Route.InvestorsNeighbourhoodPage && isCompare:
      headerNameContent = <SmallText weight="bold">{t('investors.compare.sticky.title')}</SmallText>;
      break;
    case route.name === Route.InvestorsNeighbourhoodPage && !isCompare:
      headerNameContent = localData ? (
        <div style={{ textAlign: 'center' }}>
          <SmallText weight="bold">{localData.neighbourhood}</SmallText>
          <div style={{ fontSize: 11 }}>{localData.city}</div>
        </div>
      ) : null;
      break;
  }

  return (
    <Wrapper>
      <LogoWrapper>
        {withBackLink ? headerNameContent : <Logo route={Route.InvestorsHomePage} />}
      </LogoWrapper>

      <UserMenuWrapper>
        {withBackLink ? <ArrowRightIcon onClick={handleClick} /> : <UserMenu onLogout={onLogout} />}
      </UserMenuWrapper>

      <ExtraMobileActionsWrapper>
        {/* Paste here any page-dependent mobile header widgets if needed */}
        <HeaderSaveNeighbourhoodWidget />
      </ExtraMobileActionsWrapper>
    </Wrapper>
  );
};

const mapStateToProps = (state: State) => ({
  route: routeSelector(state),
  prevRoute: prevRouteSelector(state),
  localData: neighborhoodSummaryDemographicSelector(state),
});

const mapDispatchToProps = {
  navigate: navigateTo,
};

export const Header = connect(mapStateToProps, mapDispatchToProps)(HeaderBase);
